import { put, call, take, fork, cancel, select } from "redux-saga/effects";

import { delay } from "redux-saga";

import { translateTextReq } from "../api/translate";

import {
  TRANSLATE_TEXT,
  SET_TRANSLATED_TEXT,
  TRANSLATION_LOADING,
  TRANSLATED_TEXT_ERROR
} from "../constants/translator";

export const translateText = function* translateText() {
  yield call(delay, 500);
  yield put({ type: TRANSLATION_LOADING });
  const data = yield select(state => state.translator.settings);
  try {
    const response = yield call(translateTextReq, data);
    yield put({ type: SET_TRANSLATED_TEXT, ...response });
  } catch (error) {
    yield put({ type: TRANSLATED_TEXT_ERROR, error });
  }
};

export const watchTranslateText = function* watchTranslateText() {
  let task;
  while (true) {
    yield take(TRANSLATE_TEXT);
    if (task) {
      yield cancel(task);
    }
    task = yield fork(translateText);
  }
};



// WEBPACK FOOTER //
// ./src/sagas/translate.js